/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import {
  BaseApiClient,
  RequestContext,
  ApiConfigManager,
  HttpRequestState,
} from '@sg/api/base-api-lib';
import { LegalEntitiesApiConfig } from '../api-config';

import { LegalEntitiesApi } from '../models';

@Injectable()
export class LegalEntitiesApiClient extends BaseApiClient<LegalEntitiesApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.legalEntitiesApiConfig);
  }

  legalEntitiesControllerGetLegalEntityById(
    params: { xSgUser?: string; id: string; inheritance?: boolean },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    | LegalEntitiesApi.StandardLenderDto
    | LegalEntitiesApi.SubLenderDto
    | LegalEntitiesApi.SuperLenderDto
    | LegalEntitiesApi.BorrowerDto
  >;
  legalEntitiesControllerGetLegalEntityById(
    params: { xSgUser?: string; id: string; inheritance?: boolean },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerGetLegalEntityById(
    params: { xSgUser?: string; id: string; inheritance?: boolean },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    | LegalEntitiesApi.StandardLenderDto
    | LegalEntitiesApi.SubLenderDto
    | LegalEntitiesApi.SuperLenderDto
    | LegalEntitiesApi.BorrowerDto
  >;
  legalEntitiesControllerGetLegalEntityById(
    params: { xSgUser?: string; id: string; inheritance?: boolean },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerGetLegalEntityById(
    params: { xSgUser?: string; id: string; inheritance?: boolean },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerGetLegalEntityById(
    params: { xSgUser?: string; id: string; inheritance?: boolean },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerGetLegalEntityById(
    params: { xSgUser?: string; id: string; inheritance?: boolean },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    requestContext.queryParams = this.createQueryParams(['', 'inheritance', params.inheritance]);

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerUpdateLegalEntityById(
    params: {
      body?:
        | LegalEntitiesApi.UpdateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSubLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    | LegalEntitiesApi.StandardLenderDto
    | LegalEntitiesApi.SubLenderDto
    | LegalEntitiesApi.SuperLenderDto
    | LegalEntitiesApi.BorrowerDto
  >;
  legalEntitiesControllerUpdateLegalEntityById(
    params: {
      body?:
        | LegalEntitiesApi.UpdateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSubLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLegalEntityById(
    params: {
      body?:
        | LegalEntitiesApi.UpdateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSubLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    | LegalEntitiesApi.StandardLenderDto
    | LegalEntitiesApi.SubLenderDto
    | LegalEntitiesApi.SuperLenderDto
    | LegalEntitiesApi.BorrowerDto
  >;
  legalEntitiesControllerUpdateLegalEntityById(
    params: {
      body?:
        | LegalEntitiesApi.UpdateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSubLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLegalEntityById(
    params: {
      body?:
        | LegalEntitiesApi.UpdateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSubLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLegalEntityById(
    params: {
      body?:
        | LegalEntitiesApi.UpdateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSubLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLegalEntityById(
    params: {
      body?:
        | LegalEntitiesApi.UpdateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSubLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.UpdateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(
      options.headers || {},
      ['x-sg-user', params.xSgUser],
      ['idempotencykey', params.idempotencykey],
    );

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerGetLegalEntitiesBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>;
  legalEntitiesControllerGetLegalEntitiesBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>;
  legalEntitiesControllerGetLegalEntitiesBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    if (params) {
      requestContext.queryParams = this.createQueryParams(
        ['', 'pageSize', params.pageSize],
        ['', 'pageNumber', params.pageNumber],
        ['', 'sortDirection', params.sortDirection],
        ['', 'orderBy', params.orderBy],
      );
    }

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params?.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ =
      this.httpClient.post<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>(
        `${this.basePath}/gateway/admin/legal-entities/search`,
        params?.body,
        <any>Object.assign(baseOptions, {}),
      );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerCreateLegalEntity(
    params?: {
      body?:
        | LegalEntitiesApi.CreateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSubLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.CreateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    | LegalEntitiesApi.StandardLenderDto
    | LegalEntitiesApi.SubLenderDto
    | LegalEntitiesApi.SuperLenderDto
    | LegalEntitiesApi.BorrowerDto
  >;
  legalEntitiesControllerCreateLegalEntity(
    params?: {
      body?:
        | LegalEntitiesApi.CreateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSubLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.CreateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerCreateLegalEntity(
    params?: {
      body?:
        | LegalEntitiesApi.CreateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSubLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.CreateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    | LegalEntitiesApi.StandardLenderDto
    | LegalEntitiesApi.SubLenderDto
    | LegalEntitiesApi.SuperLenderDto
    | LegalEntitiesApi.BorrowerDto
  >;
  legalEntitiesControllerCreateLegalEntity(
    params?: {
      body?:
        | LegalEntitiesApi.CreateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSubLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.CreateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerCreateLegalEntity(
    params?: {
      body?:
        | LegalEntitiesApi.CreateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSubLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.CreateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerCreateLegalEntity(
    params?: {
      body?:
        | LegalEntitiesApi.CreateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSubLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.CreateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerCreateLegalEntity(
    params?: {
      body?:
        | LegalEntitiesApi.CreateStandardLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSubLenderLegalEntityRequest
        | LegalEntitiesApi.CreateSuperLenderLegalEntityRequest
        | LegalEntitiesApi.CreateBorrowerLegalEntityRequest;
      xSgUser?: string;
      idempotencykey?: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(
      options.headers || {},
      ['x-sg-user', params?.xSgUser],
      ['idempotencykey', params?.idempotencykey],
    );

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >(
      `${this.basePath}/gateway/admin/legal-entities`,
      params?.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerUpdateLegalEntityApprovedEntities(
    params: {
      body: LegalEntitiesApi.UpsertApprovedEntitiesRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.UpsertApprovedEntitiesResponse>;
  legalEntitiesControllerUpdateLegalEntityApprovedEntities(
    params: {
      body: LegalEntitiesApi.UpsertApprovedEntitiesRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.UpsertApprovedEntitiesResponse>>;
  legalEntitiesControllerUpdateLegalEntityApprovedEntities(
    params: {
      body: LegalEntitiesApi.UpsertApprovedEntitiesRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.UpsertApprovedEntitiesResponse>;
  legalEntitiesControllerUpdateLegalEntityApprovedEntities(
    params: {
      body: LegalEntitiesApi.UpsertApprovedEntitiesRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.UpsertApprovedEntitiesResponse>>;
  legalEntitiesControllerUpdateLegalEntityApprovedEntities(
    params: {
      body: LegalEntitiesApi.UpsertApprovedEntitiesRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.UpsertApprovedEntitiesResponse>>;
  legalEntitiesControllerUpdateLegalEntityApprovedEntities(
    params: {
      body: LegalEntitiesApi.UpsertApprovedEntitiesRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.UpsertApprovedEntitiesResponse>>;
  legalEntitiesControllerUpdateLegalEntityApprovedEntities(
    params: {
      body: LegalEntitiesApi.UpsertApprovedEntitiesRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(
      options.headers || {},
      ['x-sg-user', params.xSgUser],
      ['idempotencykey', params.idempotencykey],
    );

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<LegalEntitiesApi.UpsertApprovedEntitiesResponse>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/approved-entities`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerSearchApprovedEntitiesDetails(
    params: { xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.ApprovedEntities>;
  legalEntitiesControllerSearchApprovedEntitiesDetails(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.ApprovedEntities>>;
  legalEntitiesControllerSearchApprovedEntitiesDetails(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.ApprovedEntities>;
  legalEntitiesControllerSearchApprovedEntitiesDetails(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.ApprovedEntities>>;
  legalEntitiesControllerSearchApprovedEntitiesDetails(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.ApprovedEntities>>;
  legalEntitiesControllerSearchApprovedEntitiesDetails(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.ApprovedEntities>>;
  legalEntitiesControllerSearchApprovedEntitiesDetails(
    params: { xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<LegalEntitiesApi.ApprovedEntities>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/approved-entities`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerUpdateLegalEntityActivityStatus(
    params: {
      body: LegalEntitiesApi.UpdateActivityStatusRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    | LegalEntitiesApi.StandardLenderDto
    | LegalEntitiesApi.SubLenderDto
    | LegalEntitiesApi.SuperLenderDto
    | LegalEntitiesApi.BorrowerDto
  >;
  legalEntitiesControllerUpdateLegalEntityActivityStatus(
    params: {
      body: LegalEntitiesApi.UpdateActivityStatusRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLegalEntityActivityStatus(
    params: {
      body: LegalEntitiesApi.UpdateActivityStatusRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    | LegalEntitiesApi.StandardLenderDto
    | LegalEntitiesApi.SubLenderDto
    | LegalEntitiesApi.SuperLenderDto
    | LegalEntitiesApi.BorrowerDto
  >;
  legalEntitiesControllerUpdateLegalEntityActivityStatus(
    params: {
      body: LegalEntitiesApi.UpdateActivityStatusRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLegalEntityActivityStatus(
    params: {
      body: LegalEntitiesApi.UpdateActivityStatusRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLegalEntityActivityStatus(
    params: {
      body: LegalEntitiesApi.UpdateActivityStatusRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLegalEntityActivityStatus(
    params: {
      body: LegalEntitiesApi.UpdateActivityStatusRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(
      options.headers || {},
      ['x-sg-user', params.xSgUser],
      ['idempotencykey', params.idempotencykey],
    );

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/activity-status`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerGetLegalEntityMatchesById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<string>>;
  legalEntitiesControllerGetLegalEntityMatchesById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<string>>>;
  legalEntitiesControllerGetLegalEntityMatchesById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<string>>;
  legalEntitiesControllerGetLegalEntityMatchesById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<string>>>;
  legalEntitiesControllerGetLegalEntityMatchesById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<string>>>;
  legalEntitiesControllerGetLegalEntityMatchesById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<string>>>;
  legalEntitiesControllerGetLegalEntityMatchesById(
    params: { xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<string>>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/matches`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerGetLegalEntityAccountById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    | LegalEntitiesApi.AccountResponse
    | LegalEntitiesApi.MinorAccountResponse
    | LegalEntitiesApi.SubAccountResponse
  >;
  legalEntitiesControllerGetLegalEntityAccountById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<
      | LegalEntitiesApi.AccountResponse
      | LegalEntitiesApi.MinorAccountResponse
      | LegalEntitiesApi.SubAccountResponse
    >
  >;
  legalEntitiesControllerGetLegalEntityAccountById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    | LegalEntitiesApi.AccountResponse
    | LegalEntitiesApi.MinorAccountResponse
    | LegalEntitiesApi.SubAccountResponse
  >;
  legalEntitiesControllerGetLegalEntityAccountById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<
      | LegalEntitiesApi.AccountResponse
      | LegalEntitiesApi.MinorAccountResponse
      | LegalEntitiesApi.SubAccountResponse
    >
  >;
  legalEntitiesControllerGetLegalEntityAccountById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<
      | LegalEntitiesApi.AccountResponse
      | LegalEntitiesApi.MinorAccountResponse
      | LegalEntitiesApi.SubAccountResponse
    >
  >;
  legalEntitiesControllerGetLegalEntityAccountById(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<
      | LegalEntitiesApi.AccountResponse
      | LegalEntitiesApi.MinorAccountResponse
      | LegalEntitiesApi.SubAccountResponse
    >
  >;
  legalEntitiesControllerGetLegalEntityAccountById(
    params: { xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<
      | LegalEntitiesApi.AccountResponse
      | LegalEntitiesApi.MinorAccountResponse
      | LegalEntitiesApi.SubAccountResponse
    >(
      `${this.basePath}/gateway/admin/legal-entities/accounts/${this.encodeURI(String(params.id))}`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerGetLegalEntitiesAccountsBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesAccountRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'custodianId' | 'defaultSort' | 'accountId' | 'legalEntityId' | 'salesPortfolioId';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.BaseAccountResponseSearchLegalEntitiesAccountsOrderDtoPagingResultDto>;
  legalEntitiesControllerGetLegalEntitiesAccountsBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesAccountRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'custodianId' | 'defaultSort' | 'accountId' | 'legalEntityId' | 'salesPortfolioId';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<LegalEntitiesApi.BaseAccountResponseSearchLegalEntitiesAccountsOrderDtoPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesAccountsBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesAccountRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'custodianId' | 'defaultSort' | 'accountId' | 'legalEntityId' | 'salesPortfolioId';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.BaseAccountResponseSearchLegalEntitiesAccountsOrderDtoPagingResultDto>;
  legalEntitiesControllerGetLegalEntitiesAccountsBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesAccountRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'custodianId' | 'defaultSort' | 'accountId' | 'legalEntityId' | 'salesPortfolioId';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<LegalEntitiesApi.BaseAccountResponseSearchLegalEntitiesAccountsOrderDtoPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesAccountsBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesAccountRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'custodianId' | 'defaultSort' | 'accountId' | 'legalEntityId' | 'salesPortfolioId';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<LegalEntitiesApi.BaseAccountResponseSearchLegalEntitiesAccountsOrderDtoPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesAccountsBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesAccountRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'custodianId' | 'defaultSort' | 'accountId' | 'legalEntityId' | 'salesPortfolioId';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<LegalEntitiesApi.BaseAccountResponseSearchLegalEntitiesAccountsOrderDtoPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesAccountsBySearchParams(
    params?: {
      body?: LegalEntitiesApi.SearchLegalEntitiesAccountRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'custodianId' | 'defaultSort' | 'accountId' | 'legalEntityId' | 'salesPortfolioId';
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    if (params) {
      requestContext.queryParams = this.createQueryParams(
        ['', 'pageSize', params.pageSize],
        ['', 'pageNumber', params.pageNumber],
        ['', 'sortDirection', params.sortDirection],
        ['', 'orderBy', params.orderBy],
      );
    }

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params?.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ =
      this.httpClient.post<LegalEntitiesApi.BaseAccountResponseSearchLegalEntitiesAccountsOrderDtoPagingResultDto>(
        `${this.basePath}/gateway/admin/legal-entities/accounts/search`,
        params?.body,
        <any>Object.assign(baseOptions, {}),
      );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerGetLegalEntityAccountMatchedCodesById(
    params: { xSgUser?: string; sourceLeId: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<LegalEntitiesApi.MatchedCodeDto>>;
  legalEntitiesControllerGetLegalEntityAccountMatchedCodesById(
    params: { xSgUser?: string; sourceLeId: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<LegalEntitiesApi.MatchedCodeDto>>>;
  legalEntitiesControllerGetLegalEntityAccountMatchedCodesById(
    params: { xSgUser?: string; sourceLeId: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<LegalEntitiesApi.MatchedCodeDto>>;
  legalEntitiesControllerGetLegalEntityAccountMatchedCodesById(
    params: { xSgUser?: string; sourceLeId: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<LegalEntitiesApi.MatchedCodeDto>>>;
  legalEntitiesControllerGetLegalEntityAccountMatchedCodesById(
    params: { xSgUser?: string; sourceLeId: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<LegalEntitiesApi.MatchedCodeDto>>>;
  legalEntitiesControllerGetLegalEntityAccountMatchedCodesById(
    params: { xSgUser?: string; sourceLeId: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<LegalEntitiesApi.MatchedCodeDto>>>;
  legalEntitiesControllerGetLegalEntityAccountMatchedCodesById(
    params: { xSgUser?: string; sourceLeId: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['sourceLeId', params.sourceLeId]);

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<LegalEntitiesApi.MatchedCodeDto>>(
      `${this.basePath}/gateway/admin/legal-entities/accounts/${this.encodeURI(String(params.sourceLeId))}/matched-codes`,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerUpdateLegalEntityAccountMatchedCodes(
    params?: { body?: LegalEntitiesApi.MatchedCodesUpdateRequest; xSgUser?: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.ErrorResponse>;
  legalEntitiesControllerUpdateLegalEntityAccountMatchedCodes(
    params?: { body?: LegalEntitiesApi.MatchedCodesUpdateRequest; xSgUser?: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.ErrorResponse>>;
  legalEntitiesControllerUpdateLegalEntityAccountMatchedCodes(
    params?: { body?: LegalEntitiesApi.MatchedCodesUpdateRequest; xSgUser?: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.ErrorResponse>;
  legalEntitiesControllerUpdateLegalEntityAccountMatchedCodes(
    params?: { body?: LegalEntitiesApi.MatchedCodesUpdateRequest; xSgUser?: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.ErrorResponse>>;
  legalEntitiesControllerUpdateLegalEntityAccountMatchedCodes(
    params?: { body?: LegalEntitiesApi.MatchedCodesUpdateRequest; xSgUser?: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.ErrorResponse>>;
  legalEntitiesControllerUpdateLegalEntityAccountMatchedCodes(
    params?: { body?: LegalEntitiesApi.MatchedCodesUpdateRequest; xSgUser?: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.ErrorResponse>>;
  legalEntitiesControllerUpdateLegalEntityAccountMatchedCodes(
    params?: { body?: LegalEntitiesApi.MatchedCodesUpdateRequest; xSgUser?: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params?.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<LegalEntitiesApi.ErrorResponse>(
      `${this.basePath}/gateway/admin/legal-entities/accounts/matched-codes`,
      params?.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerSearchRatesByDate(
    params: {
      body?: LegalEntitiesApi.SearchLenderRatesByDateRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<LegalEntitiesApi.LenderRatesDto>>;
  legalEntitiesControllerSearchRatesByDate(
    params: {
      body?: LegalEntitiesApi.SearchLenderRatesByDateRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<LegalEntitiesApi.LenderRatesDto>>>;
  legalEntitiesControllerSearchRatesByDate(
    params: {
      body?: LegalEntitiesApi.SearchLenderRatesByDateRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<LegalEntitiesApi.LenderRatesDto>>;
  legalEntitiesControllerSearchRatesByDate(
    params: {
      body?: LegalEntitiesApi.SearchLenderRatesByDateRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<LegalEntitiesApi.LenderRatesDto>>>;
  legalEntitiesControllerSearchRatesByDate(
    params: {
      body?: LegalEntitiesApi.SearchLenderRatesByDateRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<LegalEntitiesApi.LenderRatesDto>>>;
  legalEntitiesControllerSearchRatesByDate(
    params: {
      body?: LegalEntitiesApi.SearchLenderRatesByDateRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<LegalEntitiesApi.LenderRatesDto>>>;
  legalEntitiesControllerSearchRatesByDate(
    params: {
      body?: LegalEntitiesApi.SearchLenderRatesByDateRequest;
      xSgUser?: string;
      id: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<LegalEntitiesApi.LenderRatesDto>>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/search-rates-by-date`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerUpdateLenderRatesByDate(
    params: {
      body?: LegalEntitiesApi.UpdateLenderRatesByDateRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    | LegalEntitiesApi.StandardLenderDto
    | LegalEntitiesApi.SubLenderDto
    | LegalEntitiesApi.SuperLenderDto
    | LegalEntitiesApi.BorrowerDto
  >;
  legalEntitiesControllerUpdateLenderRatesByDate(
    params: {
      body?: LegalEntitiesApi.UpdateLenderRatesByDateRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLenderRatesByDate(
    params: {
      body?: LegalEntitiesApi.UpdateLenderRatesByDateRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    | LegalEntitiesApi.StandardLenderDto
    | LegalEntitiesApi.SubLenderDto
    | LegalEntitiesApi.SuperLenderDto
    | LegalEntitiesApi.BorrowerDto
  >;
  legalEntitiesControllerUpdateLenderRatesByDate(
    params: {
      body?: LegalEntitiesApi.UpdateLenderRatesByDateRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLenderRatesByDate(
    params: {
      body?: LegalEntitiesApi.UpdateLenderRatesByDateRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLenderRatesByDate(
    params: {
      body?: LegalEntitiesApi.UpdateLenderRatesByDateRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >
  >;
  legalEntitiesControllerUpdateLenderRatesByDate(
    params: {
      body?: LegalEntitiesApi.UpdateLenderRatesByDateRequest;
      xSgUser?: string;
      idempotencykey?: string;
      id: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(
      options.headers || {},
      ['x-sg-user', params.xSgUser],
      ['idempotencykey', params.idempotencykey],
    );

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<
      | LegalEntitiesApi.StandardLenderDto
      | LegalEntitiesApi.SubLenderDto
      | LegalEntitiesApi.SuperLenderDto
      | LegalEntitiesApi.BorrowerDto
    >(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/update-rates-by-date`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerSearchLendersCashFeeSplits(
    params?: {
      body?: LegalEntitiesApi.SearchLendersCashFeeSplitsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.CashFeeSplitsResponseSearchLegalEntitiesOrderPagingResultDto>;
  legalEntitiesControllerSearchLendersCashFeeSplits(
    params?: {
      body?: LegalEntitiesApi.SearchLendersCashFeeSplitsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<LegalEntitiesApi.CashFeeSplitsResponseSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerSearchLendersCashFeeSplits(
    params?: {
      body?: LegalEntitiesApi.SearchLendersCashFeeSplitsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.CashFeeSplitsResponseSearchLegalEntitiesOrderPagingResultDto>;
  legalEntitiesControllerSearchLendersCashFeeSplits(
    params?: {
      body?: LegalEntitiesApi.SearchLendersCashFeeSplitsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<LegalEntitiesApi.CashFeeSplitsResponseSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerSearchLendersCashFeeSplits(
    params?: {
      body?: LegalEntitiesApi.SearchLendersCashFeeSplitsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<LegalEntitiesApi.CashFeeSplitsResponseSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerSearchLendersCashFeeSplits(
    params?: {
      body?: LegalEntitiesApi.SearchLendersCashFeeSplitsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<LegalEntitiesApi.CashFeeSplitsResponseSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerSearchLendersCashFeeSplits(
    params?: {
      body?: LegalEntitiesApi.SearchLendersCashFeeSplitsRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    const consumes = ['application/json'];

    if (params) {
      requestContext.queryParams = this.createQueryParams(
        ['', 'pageSize', params.pageSize],
        ['', 'pageNumber', params.pageNumber],
        ['', 'sortDirection', params.sortDirection],
        ['', 'orderBy', params.orderBy],
      );
    }

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params?.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ =
      this.httpClient.post<LegalEntitiesApi.CashFeeSplitsResponseSearchLegalEntitiesOrderPagingResultDto>(
        `${this.basePath}/gateway/admin/legal-entities/search-cash-feesplits`,
        params?.body,
        <any>Object.assign(baseOptions, {}),
      );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerSearchLenderCashFeeSplits(
    params: {
      body?: LegalEntitiesApi.SearchLenderCashFeeSplitsRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.CashFeeSplitsResponse>;
  legalEntitiesControllerSearchLenderCashFeeSplits(
    params: {
      body?: LegalEntitiesApi.SearchLenderCashFeeSplitsRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.CashFeeSplitsResponse>>;
  legalEntitiesControllerSearchLenderCashFeeSplits(
    params: {
      body?: LegalEntitiesApi.SearchLenderCashFeeSplitsRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.CashFeeSplitsResponse>;
  legalEntitiesControllerSearchLenderCashFeeSplits(
    params: {
      body?: LegalEntitiesApi.SearchLenderCashFeeSplitsRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.CashFeeSplitsResponse>>;
  legalEntitiesControllerSearchLenderCashFeeSplits(
    params: {
      body?: LegalEntitiesApi.SearchLenderCashFeeSplitsRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.CashFeeSplitsResponse>>;
  legalEntitiesControllerSearchLenderCashFeeSplits(
    params: {
      body?: LegalEntitiesApi.SearchLenderCashFeeSplitsRequest;
      xSgUser?: string;
      id: string;
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.CashFeeSplitsResponse>>;
  legalEntitiesControllerSearchLenderCashFeeSplits(
    params: {
      body?: LegalEntitiesApi.SearchLenderCashFeeSplitsRequest;
      xSgUser?: string;
      id: string;
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<LegalEntitiesApi.CashFeeSplitsResponse>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/search-cash-feesplits`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdByDateRange(
    params: { body: LegalEntitiesApi.DateRangeRequestDto; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<LegalEntitiesApi.AccountFeeSplitResponse>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdByDateRange(
    params: { body: LegalEntitiesApi.DateRangeRequestDto; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<LegalEntitiesApi.AccountFeeSplitResponse>>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdByDateRange(
    params: { body: LegalEntitiesApi.DateRangeRequestDto; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<LegalEntitiesApi.AccountFeeSplitResponse>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdByDateRange(
    params: { body: LegalEntitiesApi.DateRangeRequestDto; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<LegalEntitiesApi.AccountFeeSplitResponse>>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdByDateRange(
    params: { body: LegalEntitiesApi.DateRangeRequestDto; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<LegalEntitiesApi.AccountFeeSplitResponse>>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdByDateRange(
    params: { body: LegalEntitiesApi.DateRangeRequestDto; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<LegalEntitiesApi.AccountFeeSplitResponse>>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdByDateRange(
    params: { body: LegalEntitiesApi.DateRangeRequestDto; xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<LegalEntitiesApi.AccountFeeSplitResponse>>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/fee-splits/search-by-date-range`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdNonMinor(
    params: { xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<Array<LegalEntitiesApi.LegalEntityFeeSplitsDto>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdNonMinor(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<Array<LegalEntitiesApi.LegalEntityFeeSplitsDto>>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdNonMinor(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<Array<LegalEntitiesApi.LegalEntityFeeSplitsDto>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdNonMinor(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<Array<LegalEntitiesApi.LegalEntityFeeSplitsDto>>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdNonMinor(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<Array<LegalEntitiesApi.LegalEntityFeeSplitsDto>>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdNonMinor(
    params: { xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<Array<LegalEntitiesApi.LegalEntityFeeSplitsDto>>>;
  legalEntitiesControllerSearchFeeSplitsByLegalEntityIdNonMinor(
    params: { xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<Array<LegalEntitiesApi.LegalEntityFeeSplitsDto>>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/fee-splits/search-non-minor`,
      null,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerUploadLenderRecommendations(
    params: { file: Blob; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.UploadRecommendationsResponseDto>;
  legalEntitiesControllerUploadLenderRecommendations(
    params: { file: Blob; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<HttpResponse<LegalEntitiesApi.UploadRecommendationsResponseDto>>;
  legalEntitiesControllerUploadLenderRecommendations(
    params: { file: Blob; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.UploadRecommendationsResponseDto>;
  legalEntitiesControllerUploadLenderRecommendations(
    params: { file: Blob; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpRequestState<LegalEntitiesApi.UploadRecommendationsResponseDto>>;
  legalEntitiesControllerUploadLenderRecommendations(
    params: { file: Blob; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpResponse<LegalEntitiesApi.UploadRecommendationsResponseDto>>;
  legalEntitiesControllerUploadLenderRecommendations(
    params: { file: Blob; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<HttpEvent<LegalEntitiesApi.UploadRecommendationsResponseDto>>;
  legalEntitiesControllerUploadLenderRecommendations(
    params: { file: Blob; xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['file', params.file], ['id', params.id]);

    const consumes = ['multipart/form-data'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    const rawFormParams: Array<[string, string, any] | [string, string, any[], boolean]> = [
      ['file', 'file', params.file],
    ];
    const formParams = this.canConsumeForm(consumes)
      ? this.createFormDataParams(...rawFormParams)
      : this.createQueryParams(...rawFormParams);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.post<LegalEntitiesApi.UploadRecommendationsResponseDto>(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/lender-recommendations/upload`,
      formParams,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerSetMilestoneTargets(
    params: { body: LegalEntitiesApi.SetMilestoneTargetsRequest; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.ProblemDetails | LegalEntitiesApi.ValidationProblemDetails>;
  legalEntitiesControllerSetMilestoneTargets(
    params: { body: LegalEntitiesApi.SetMilestoneTargetsRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<LegalEntitiesApi.ProblemDetails | LegalEntitiesApi.ValidationProblemDetails>
  >;
  legalEntitiesControllerSetMilestoneTargets(
    params: { body: LegalEntitiesApi.SetMilestoneTargetsRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.ProblemDetails | LegalEntitiesApi.ValidationProblemDetails>;
  legalEntitiesControllerSetMilestoneTargets(
    params: { body: LegalEntitiesApi.SetMilestoneTargetsRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<LegalEntitiesApi.ProblemDetails | LegalEntitiesApi.ValidationProblemDetails>
  >;
  legalEntitiesControllerSetMilestoneTargets(
    params: { body: LegalEntitiesApi.SetMilestoneTargetsRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<LegalEntitiesApi.ProblemDetails | LegalEntitiesApi.ValidationProblemDetails>
  >;
  legalEntitiesControllerSetMilestoneTargets(
    params: { body: LegalEntitiesApi.SetMilestoneTargetsRequest; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<LegalEntitiesApi.ProblemDetails | LegalEntitiesApi.ValidationProblemDetails>
  >;
  legalEntitiesControllerSetMilestoneTargets(
    params: { body: LegalEntitiesApi.SetMilestoneTargetsRequest; xSgUser?: string; id: string },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body], ['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<
      LegalEntitiesApi.ProblemDetails | LegalEntitiesApi.ValidationProblemDetails
    >(
      `${this.basePath}/gateway/admin/legal-entities/${this.encodeURI(String(params.id))}/milestone-targets`,
      params.body,
      <any>Object.assign(baseOptions, {}),
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  legalEntitiesControllerGetLegalEntitiesByPartialCode(
    params: {
      body: LegalEntitiesApi.SearchLegalEntitiesByPartialCodeRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>;
  legalEntitiesControllerGetLegalEntitiesByPartialCode(
    params: {
      body: LegalEntitiesApi.SearchLegalEntitiesByPartialCodeRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Promise<
    HttpResponse<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesByPartialCode(
    params: {
      body: LegalEntitiesApi.SearchLegalEntitiesByPartialCodeRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>;
  legalEntitiesControllerGetLegalEntitiesByPartialCode(
    params: {
      body: LegalEntitiesApi.SearchLegalEntitiesByPartialCodeRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpRequestState<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesByPartialCode(
    params: {
      body: LegalEntitiesApi.SearchLegalEntitiesByPartialCodeRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpResponse<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesByPartialCode(
    params: {
      body: LegalEntitiesApi.SearchLegalEntitiesByPartialCodeRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    },
  ): Observable<
    HttpEvent<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>
  >;
  legalEntitiesControllerGetLegalEntitiesByPartialCode(
    params: {
      body: LegalEntitiesApi.SearchLegalEntitiesByPartialCodeRequest;
      xSgUser?: string;
      pageSize?: number;
      pageNumber?: number;
      sortDirection?: 'asc' | 'desc';
      orderBy?: 'default' | 'name' | 'type';
    },
    options: {
      observe?:
        | 'responsePromise'
        | 'bodyPromise'
        | 'response'
        | 'body'
        | 'bodyWithState'
        | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {},
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['body', params.body]);

    const consumes = ['application/json'];

    requestContext.queryParams = this.createQueryParams(
      ['', 'pageSize', params.pageSize],
      ['', 'pageNumber', params.pageNumber],
      ['', 'sortDirection', params.sortDirection],
      ['', 'orderBy', params.orderBy],
    );

    requestContext.headers = this.createHeaders(options.headers || {}, [
      'x-sg-user',
      params.xSgUser,
    ]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ =
      this.httpClient.post<LegalEntitiesApi.LegalEntityBaseDtoSearchLegalEntitiesOrderPagingResultDto>(
        `${this.basePath}/gateway/admin/legal-entities/search/by-partial-code`,
        params.body,
        <any>Object.assign(baseOptions, {}),
      );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
